// hospitalStampApi.ts
import { serverApi, handleApiResponse } from "@core/api/core"
import { CommonTResponse } from "@/types/common"

// 도장 이미지 정보 타입
export interface HospitalStampSerializer {
  stampName?: string
  filename?: string
  uploadedBy?: string
  uploadedDt?: string
  usable?: boolean
  fileExists?: boolean
}

// 도장 이미지 공개 조회 응답 타입
export interface HospitalStampPublicResponse {
  stampImage?: string // Base64 data URI
  stampName?: string
}

/**
 * 도장 이미지 업로드
 * @param file - PNG 또는 SVG 파일
 * @param stampName - 도장 이름 (예: "해나한의원")
 */
export const uploadStampApi = async (file: File, stampName: string): Promise<HospitalStampSerializer> => {
  const formData = new FormData()
  formData.append("file", file)
  formData.append("stamp_name", stampName)

  const response = await serverApi.post(`/hospital/stamp/upload/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  })
  return handleApiResponse<HospitalStampSerializer>(response)
}

/**
 * 저장된 도장 이미지 조회 (단일 객체)
 */
export const getStampApi = async (): Promise<HospitalStampSerializer | null> => {
  try {
    const response = await serverApi.get(`/hospital/stamp/`)
    return handleApiResponse<HospitalStampSerializer>(response)
  } catch (error: any) {
    // 404는 정상 (도장 없음)
    if (error?.response?.status === 404) {
      return null
    }
    throw error
  }
}

/**
 * 도장 이미지 삭제 (모든 도장 파일 및 메타데이터)
 */
export const deleteStampApi = async (): Promise<{ deleted: boolean }> => {
  const response = await serverApi.post(`/hospital/stamp/delete/`)
  return handleApiResponse<{ deleted: boolean }>(response)
}

/**
 * 도장 이미지 사용 가능 여부 토글
 * @deprecated 현재 앱에서는 사용하지 않지만, 구버전 클라이언트 하위호환을 위해 유지한다.
 */
export const toggleStampUsableApi = async (): Promise<{ usable: boolean }> => {
  const response = await serverApi.post(`/hospital/stamp/toggle-usable/`)
  return handleApiResponse<{ usable: boolean }>(response)
}

/**
 * 도장 이미지 조회 (관리자용 - Base64)
 * @returns Base64 인코딩된 도장 이미지 data URI
 */
export const getStampImageApi = async (): Promise<HospitalStampPublicResponse> => {
  const response = await serverApi.get(`/hospital/stamp/image/`)
  return handleApiResponse<HospitalStampPublicResponse>(response)
}

/**
 * 도장 이미지 공개 조회 (인증 불필요)
 * @returns Base64 인코딩된 도장 이미지 data URI
 */
export const getPublicStampApi = async (): Promise<HospitalStampPublicResponse> => {
  const response = await serverApi.get(`/hospital/public/stamp/`)
  // console.log("🔓 공개 도장 이미지 조회 응답:", response)
  return handleApiResponse<HospitalStampPublicResponse>(response)
}
